<template>
    <v-layout>
        <v-flex xs12 lg10 offset-lg1>
            <v-flex v-if="$store.state.usuario.type == 'COMERCIAL'"><cabeceraPedido/></v-flex>
            <Pedido  v-if="windowSize.x > 960" />
            <PedidoMobile  v-if="windowSize.x <= 960" />
        </v-flex>
        <dialogTipoCobro/>
    </v-layout>
</template>
<script>
import Pedido from '@/components/pedido'
import PedidoMobile from '@/components/pedidoMobile'
import cabeceraPedido from '@/components/cabeceraPedido'
import dialogTipoCobro from '@/components/dialogTipoCobro'
export default {
    name: 'VistaPedido'   ,
    components:{
        Pedido,
        PedidoMobile,
        cabeceraPedido,
        dialogTipoCobro
    },
    computed:{
        windowSize:{
            get(){
                return this.$store.state.windowSize;
            },
            set(value){
                this.$store.state.windowSize = value;
            }
        },
    }
}
</script>

